$(document).on('click', '.b-table-switcher', function () {
  var isTable = $(this).data('type') === 'table'
  $(this).siblings('.table-wrapper').toggleClass('has-mobile-cards', !isTable).find('.span-hidden-mobile').toggleClass('is-hidden-mobile', !isTable);
});
